import React, { useEffect, useState } from "react";
import "./styles/LoginScreen.css";
import {
  Alert,
  Checkbox,
  FormControlLabel,
  Paper,
  TextField,
  Typography,
  Box,
  Button,
  CircularProgress,
  Divider,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import { errorToast, successToast } from "../../../services/toast.service";
import useAuth from "./hooks/useAuth";
import TokenPersistenceManager from "../../../services/tokenPersistenceManager";
import { useNavigate } from "react-router-dom";

export default function LoginScreen() {
  const navigate = useNavigate();
  const token = TokenPersistenceManager.getToken();
  const [userType, setUserType] = useState("Admin");
  const [username, setUsername] = useState("demoadmin");
  const [password, setPassword] = useState("admin@1234");
  const [storeId, setStoreId] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const { onUserLogin, onAdminLogin, loginError, isLoading } = useAuth();

  useEffect(() => {
    if (token) navigate("/");
  }, [token]);

  const handleUserTypeChange = type => {
    // Only clear storeId, keep username and password
    setStoreId("");
    setUserType(type);
  };

  const handleLogin = async () => {
    // Form validation
    if (!username) {
      errorToast("Username/Email is required.");
      return;
    }
    if (!password) {
      errorToast("Password is required.");
      return;
    }
    if (userType === "Employee" && !storeId) {
      errorToast("Store ID is required.");
      return;
    }

    const success =
      userType === "Employee"
        ? await onUserLogin(storeId, username, password)
        : await onAdminLogin(
            username == "demoadmin" ? "solemateadmin" : username,
            password,
          );

    if (success) {
      successToast("Login successful!");
    }
  };

  return (
    <div className="login-container">
      <div className="login-image-section">
        <img
          src={require("../../../assets/warehouse.jpeg")}
          alt="Wholesale management"
          className="login-bg-image"
        />
        <div className="login-overlay">
          <Typography variant="h4" className="overlay-text">
            Wholesale Management
          </Typography>
          <Typography variant="body1" className="overlay-subtext">
            Streamlining your business operations
          </Typography>
        </div>
      </div>

      <div className="login-form-section">
        <Paper elevation={3} className="login-paper">
          <Box className="login-header">
            <Typography variant="h4" className="login-title">
              Vyavsaay ERP
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              className="login-subtitle">
              Sign in to your account
            </Typography>
          </Box>

          <Divider className="login-divider" />

          <Box className="user-type-selector">
            <Button
              variant={userType === "Admin" ? "contained" : "outlined"}
              color="primary"
              className={`user-type-btn ${
                userType === "Admin" ? "active" : ""
              }`}
              onClick={() => handleUserTypeChange("Admin")}
              startIcon={<PersonOutlineOutlinedIcon />}>
              Admin
            </Button>
            <Button
              variant={userType === "Employee" ? "contained" : "outlined"}
              color="primary"
              className={`user-type-btn ${
                userType === "Employee" ? "active" : ""
              }`}
              disabled={true}
              startIcon={<BusinessOutlinedIcon />}>
              Employee
            </Button>
          </Box>

          <Box className="login-form">
            {userType === "Employee" && (
              <TextField
                id="store-id"
                label="Store ID"
                variant="outlined"
                fullWidth
                margin="normal"
                color="primary"
                onChange={e => setStoreId(e.target.value)}
                value={storeId}
                placeholder="Enter your store ID"
                InputProps={{
                  startAdornment: (
                    <BusinessOutlinedIcon
                      color="action"
                      className="input-icon"
                    />
                  ),
                }}
              />
            )}

            <TextField
              id="username"
              label="Username"
              variant="outlined"
              fullWidth
              margin="normal"
              color="primary"
              onChange={e => setUsername(e.target.value)}
              value={username}
              placeholder="Enter your username"
              InputProps={{
                startAdornment: (
                  <PersonOutlineOutlinedIcon
                    color="action"
                    className="input-icon"
                  />
                ),
              }}
            />

            <TextField
              id="password"
              label="Password"
              type="password"
              variant="outlined"
              fullWidth
              margin="normal"
              color="primary"
              onChange={e => setPassword(e.target.value)}
              value={password}
              placeholder="Enter your password"
              InputProps={{
                startAdornment: (
                  <LockOutlinedIcon color="action" className="input-icon" />
                ),
              }}
            />

            <Box className="login-options">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={rememberMe}
                    onChange={e => setRememberMe(e.target.checked)}
                    color="primary"
                  />
                }
                label="Remember me"
              />
              <Typography
                variant="body2"
                color="primary"
                className="forgot-password">
                Forgot password?
              </Typography>
            </Box>

            {loginError && (
              <Alert severity="error" className="login-error">
                {loginError}
              </Alert>
            )}

            <Button
              variant="contained"
              color="primary"
              fullWidth
              className="login-button"
              onClick={handleLogin}
              disabled={isLoading}>
              {isLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Sign In"
              )}
            </Button>
          </Box>
        </Paper>
      </div>
    </div>
  );
}
